$(document).ready(function() {

    var datatables_options_language = {
        "processing": "Подождите...",
        "search": "Поиск:",
        "lengthMenu": "Показать _MENU_ записей",
        "info": "Записи с _START_ до _END_ из _TOTAL_ записей",
        "infoEmpty": "Записи с 0 до 0 из 0 записей",
        "infoFiltered": "(отфильтровано из _MAX_ записей)",
        "infoPostFix": "",
        "loadingRecords": "Загрузка записей...",
        "zeroRecords": "Записи отсутствуют.",
        "emptyTable": "В таблице отсутствуют данные",
        "paginate": {
            "first": "Первая",
            "previous": "Предыдущая",
            "next": "Следующая",
            "last": "Последняя"
        },
        "select": {
            "rows": {
                "_": "Выбрано записей: %d",
                "0": "Кликните по записи для выбора",
                "1": "Выбрана одна запись"
            }
        }
    }

    var table = $('.datatables').DataTable({
        "language": datatables_options_language,
        "pageLength": 25,
        fixedHeader: true,
        dom: 'R<"dt-topbar row"<"col-sm-12 col-md-6"<"float-left mr-2"B>l><"col-sm-12 col-md-6"f>><"dt-topbar row"<"col-sm-12 col-md-6"i><"col-sm-12 col-md-6"p>>t<"dt-bottombar row"<"col-sm-12 col-md-6"i><"col-sm-12 col-md-6"p>>',
        buttons: [
            {
                extend: 'excelHtml5',
                className: 'btn btn-secondary btn-sm',
                text: 'XLSX',
                exportOptions: {
                    columns: ':visible'
                }
            },
            {
                extend: 'csvHtml5',
                className: 'btn btn-secondary btn-sm',
                exportOptions: {
                    columns: ':visible'
                }
            }
        ]
    });

    // new $.fn.dataTable.ColReorder(table);
 
    $('a.toggle-vis-dt').on( 'click', function (e) {
      
        if ($(this).hasClass("active")) {
          $(this).removeClass("active")
        } else {
          $(this).addClass("active")
        }

        e.preventDefault();
 
        // Get the column API object
        var column = table.column( $(this).attr('data-column') );
 
        // Toggle the visibility
        column.visible( ! column.visible() );
    } );

    $('.datatables_one').DataTable({ 
        "language": datatables_options_language,
        "pageLength": 5,
        "searching": false,
        "lengthChange": false
    });

    $('.datatables_two').DataTable({ 
        "language": datatables_options_language,
        "pageLength": 5,
        "searching": false,
        "lengthChange": false
    });

    $('.datatables_three').DataTable({ 
        "language": datatables_options_language,
        "pageLength": 5,
        "searching": false,
        "lengthChange": false
    });

    $('.datatables_four').DataTable({ 
        "language": datatables_options_language,
        "pageLength": 5,
        "searching": false,
        "lengthChange": false
    });

    $('.datatables_five').DataTable({ 
        "language": datatables_options_language,
        "pageLength": 5,
        "searching": false,
        "lengthChange": false
    });

    $('.landing-datatables').DataTable({
            "language": { 
                "zeroRecords": "Записи отсутствуют.",
                "paginate": { 
                    "previous": "<<", 
                    "next": ">>" }
                },
            "lengthChange": false,
            "ordering": true,
            "searching": true,
            "info": false,
            "pageLength": 20,
            "dom": "tp",
            "drawCallback": function () {
                $('.dataTables_paginate').addClass('paginate-center');
                $('.table-news thead').hide();
            }
        }
    );

    $('#documents-search').keyup(function(){
        $('.landing-datatables').DataTable().search($(this).val()).draw();
    });

    $('.ifp-datatables').DataTable({
            "language": { 
                "zeroRecords": "Записи отсутствуют.",
                "paginate": { 
                    "previous": "<<", 
                    "next": ">>" }
                },
            "lengthChange": false,
            "ordering": false,
            "searching": true,
            "info": false,
            "pageLength": 20,
            "dom": "tp",
            "drawCallback": function () {
                $('.dataTables_paginate').addClass('justify-content-center');
                $('.table-news thead').hide();
            }
        }
    );

    $('#ifp-datatable-search').keyup(function(){
        $('.ifp-datatables').DataTable().search($(this).val()).draw();
    });

});